<div class="gaps-report">
  <report-window (clickOnCloseBtn)="clickOnCloseBtnHandler()">
    <div container-header></div>
    <div container-body>
      <div class="report-header-row">
        <h3 class="report-header-dark">GAPS REPORT:</h3>
        <div class="close-gap-btn">
          <ichannel-button
            [label]="'Close Selected Gaps'"
            [theme]="selected.length > 0 ? 'DARK' : 'DIS'"
            [callback]="selected.length > 0 && closeGaps.bind(this)"
          ></ichannel-button>
        </div>
      </div>

      <div class="no-gaps-message" [hidden]="rows.length > 0 || showPreloader">
        <div class="message">
          <b>Great Job!</b>
          <br />
          You Don't have Anymore Gaps To Fill
        </div>
        <success-v-icon class="success-icon"></success-v-icon>
      </div>
      <div>
        <ngx-datatable
          class="bootstrap"
          [rows]="rows"
          [columns]="columns"
          [columnMode]="'standard'"
          [headerHeight]="50"
          [footerHeight]="20"
          [loadingIndicator]="showPreloader"
          [rowHeight]="'auto'"
          [selected]="selected"
          [selectionType]="$any('multiClick')"
          [count]="180"
          [limit]="10"
          (select)="onSelect($event)"
          [hidden]="rows.length == 0"
        >
          <ngx-datatable-column
            [width]="30"
            [sortable]="false"
            [canAutoResize]="false"
            [draggable]="false"
            [resizeable]="false"
            [checkboxable]="true"
          >
            <ng-template
              ngx-datatable-header-template
              let-value="value"
              let-allRowsSelected="allRowsSelected"
              let-selectFn="selectFn"
            >
              <div class="datatable-checkbox">
                <input
                  type="checkbox"
                  [checked]="allRowsSelected"
                  (change)="selectFn(!allRowsSelected)"
                />
              </div>
            </ng-template>
            <ng-template
              ngx-datatable-cell-template
              let-value="value"
              let-isSelected="isSelected"
              let-onCheckboxChangeFn="onCheckboxChangeFn"
            >
              <div class="datatable-checkbox">
                <!--<input type="checkbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)"/>-->
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            prop="gapShortDate"
            name="Short Date"
          ></ngx-datatable-column>
          <ngx-datatable-column prop="gapFromTime" name="From Time"
            >></ngx-datatable-column
          >
          <ngx-datatable-column
            prop="gapToTime"
            name="To Time"
          ></ngx-datatable-column>
          <ngx-datatable-column
            prop="gapDuration"
            name="Duration"
          ></ngx-datatable-column>
          <ngx-datatable-column
            prop="goToGapTicks"
            [width]="120"
            [sortable]="false"
            [canAutoResize]="false"
            [draggable]="false"
            [resizeable]="false"
            [checkboxable]="false"
          >
            <ng-template
              ngx-datatable-header-template
              let-value="value"
              let-allRowsSelected="allRowsSelected"
              let-selectFn="selectFn"
            >
              <div class="row-header">Edit</div>
            </ng-template>
            <ng-template
              ngx-datatable-cell-template
              let-value="value"
              let-isSelected="isSelected"
              let-onCheckboxChangeFn="onCheckboxChangeFn"
            >
              <div>
                <a
                  [routerLink]="['/scheduler/calendar']"
                  [queryParams]="{ t: value, vt: 'fiveMin' }"
                  queryParamsHandling="merge"
                  class="row-header"
                  >Goto Gap</a
                >
                <!--<input type="checkbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)"/>-->
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
    <!--<div class='selected-column'>
            <h4>Selections</h4>
            <ul>
                <li *ngFor='let sel of selected'>
                    {{sel.refToShowBeforeGap}}
                </li>
                <li *ngIf="!selected.length">No Selections</li>
            </ul>
        </div>-->
  </report-window>
</div>
